<template>
  <div class="team-member-card">
    <div class="image-box overflow-hidden">
      <NuxtImg
        loading="lazy"
        class="object-cover w-full h-full"
        :src="props.image ?? `/img/user.svg`"
        alt=""
        width="250"
        height="198"
      />
    </div>
    <div class="white-box">
      <div class="py-4 ml-4">
        <h5 class="white-box-title">{{ props.name }}</h5>
        <p class="position">{{ props.position }}</p>
      </div>
      <div class="absolute bottom-0 right-0 p-4">
        <!-- <NuxtImg src="~/assets/icons/mask.svg" /> -->
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  position: {
    type: String,
    required: true,
  },
  image: {
    type: String,
    required: false,
  },
});
</script>
<style scoped>
.team-member-card {
  @apply flex mx-auto w-full rounded-lg bg-white shadow-lg h-[130px] md:flex-col md:mr-4 mb-5 md:mb-0 md:w-[259px] md:h-[354px];
}
.image-box {
  @apply rounded-l-lg w-[100px] md:w-full md:h-[56%] md:rounded-l-none md:rounded-t-lg;
  background-color: inherit;
}
.white-box {
  @apply bg-white w-[70%] relative md:w-full md:h-[43%] p-2;
}
.white-box-title {
  @apply font-bold text-lg text-space-cadet;
}
.position {
  @apply text-slate-grey text-opacity-75 text-sm font-semibold;
}
</style>
